import { useEffect } from 'react';
import { log } from 'log';
import { prop, pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useLottoDestroyOnLangChange = () => {
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const { defaultLocale, stayOnLangSwitch } = useAppSelector(pick(['defaultLocale', 'stayOnLangSwitch']));

    useEffect(() => {
        if (!lang || !defaultLocale) {
            return;
        }

        const language = (lang || defaultLocale).replace('_', '-');

        if (window.Lotto?.initializationState === 'INITIALIZED' && window.Lotto?.language !== language) {
            try {
                window.Lotto.dispose();

                if (stayOnLangSwitch) {
                    dispatch(actions.setAppInitialized(false));
                } else {
                    dispatch(actions.stopIntegration());
                }
            } catch (error) {
                log('error', '[LOTTO | Portal] Destroying app error', error);
            }
        }
    }, [lang, defaultLocale, stayOnLangSwitch, dispatch]);
};
